// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   1. 레이아웃 & 컨테이너
   ========================================================================== */
   .card-news-container {
    padding: 20px;
    width: 100%;
  }
  
  .card-news-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-top: 20px;
  }
  
  .card-news-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .text-result-container{
    /* scroll-margin-top: 80px; */
    /* overflow-y: auto; */
    /* max-height: 640px; */
    scroll-margin-top: 80px;
    overflow-y: auto;
    max-height: 28vh;
    display: flex;
    flex-direction: column;
    /* background: #f8fafc; */
    border-radius: 0.375rem;
    padding: 1rem;
    margin-top: 1rem;
  }

  .img-result-container{
        /* scroll-margin-top: 80px; */
    /* overflow-y: auto; */
    /* max-height: 640px; */
    scroll-margin-top: 80px;
    overflow-y: auto;
    max-height: 40vh;
    display: flex;
    flex-direction: column;
    /* background: #f8fafc; */
    border-radius: 0.375rem;
    padding: 1rem;
    margin-top: 1rem;
  }
  
  /* ==========================================================================
     2. 카드 구조 스타일링
     ========================================================================== */
  .card-news-item {
    border: none;
    border-radius: 20px;
    overflow: hidden;
    background: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  
  .card-news-content {
    aspect-ratio: 9/16;  /* 모바일 화면 비율 */
    padding: 30px;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  /* ==========================================================================
     3. 텍스트 스타일링
     ========================================================================== */
  /* 카드 제목 */
  .card-title {
    font-size: 28px;
    font-weight: bold;
    color: #008275;  /* DB손보 브랜드 컬러 */
    text-align: center;
    word-break: keep-all;
    line-height: 1.4;
    margin-bottom: 10px;
  }
  
  /* 카드 설명 텍스트 */
  .card-description {
    font-size: 16px;
    color: #333;
    line-height: 1.8;
    word-break: keep-all;
    white-space: pre-line;
    text-align: center;
    margin: 20px 0;
  }
  
  /* 텍스트 래핑 유틸리티 */
  .text-wrap {
    white-space: pre-line;
    word-break: keep-all;
    overflow-wrap: break-word;
  }
  
  /* ==========================================================================
     4. 이미지 섹션
     ========================================================================== */
  .card-image {
    flex: 1 1;
    width: 100%;
    padding: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
  }
  
  .generated-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 15px;
  }
  
  /* ==========================================================================
     5. 푸터 영역
     ========================================================================== */
  .card-footer {
    margin-top: auto;
    padding: 20px 0;
    text-align: center;
  }
  
  .company-logo {
    height: 40px;
    object-fit: contain;
  }
  
  /* ==========================================================================
     6. 버튼 스타일링
     ========================================================================== */
  /* 버튼 컨테이너 */
  .card-news-controls {
    margin-bottom: 20px;
    text-align: center;
  }
  
  /* 전체 다운로드 버튼 */
  .download-all-button {
    background-color: #008275;
    color: white;
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    transition: all 0.3s ease;
  }
  
  .download-all-button:hover {
    background-color: #006c61;
    transform: translateY(-2px);
  }
  
  /* 개별 다운로드 버튼 */
  .download-button {
    padding: 10px 22px;
    /* background-color: #f0f0f0; */
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: bold;
    color: #333;
  }
  
  .download-button:hover {
    background-color: #e0e0e0;
    transform: translateY(-2px);
  }
  
  /* 비활성화 상태 스타일 */
  .download-button:disabled,
  .download-all-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }

  .persona-section{
    width: 100%;
  }`, "",{"version":3,"sources":["webpack://./src/css/card_demo.css"],"names":[],"mappings":"AAAA;;+EAE+E;GAC5E;IACC,aAAa;IACb,WAAW;EACb;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;EAClB;;EAEA;QACM,6BAA6B;IACjC,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;EAClB;;EAEA;;iFAE+E;EAC/E;IACE,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB,GAAG,cAAc;IACnC,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;;iFAE+E;EAC/E,UAAU;EACV;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc,GAAG,gBAAgB;IACjC,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,cAAc;EACd;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;EAChB;;EAEA,gBAAgB;EAChB;IACE,qBAAqB;IACrB,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;;iFAE+E;EAC/E;IACE,SAAO;IACP,WAAW;IACX,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;;iFAE+E;EAC/E;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;iFAE+E;EAC/E,YAAY;EACZ;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA,eAAe;EACf;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA,eAAe;EACf;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA,gBAAgB;EAChB;;IAEE,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb","sourcesContent":["/* ==========================================================================\n   1. 레이아웃 & 컨테이너\n   ========================================================================== */\n   .card-news-container {\n    padding: 20px;\n    width: 100%;\n  }\n  \n  .card-news-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n  }\n  \n  .card-news-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .text-result-container{\n    /* scroll-margin-top: 80px; */\n    /* overflow-y: auto; */\n    /* max-height: 640px; */\n    scroll-margin-top: 80px;\n    overflow-y: auto;\n    max-height: 28vh;\n    display: flex;\n    flex-direction: column;\n    /* background: #f8fafc; */\n    border-radius: 0.375rem;\n    padding: 1rem;\n    margin-top: 1rem;\n  }\n\n  .img-result-container{\n        /* scroll-margin-top: 80px; */\n    /* overflow-y: auto; */\n    /* max-height: 640px; */\n    scroll-margin-top: 80px;\n    overflow-y: auto;\n    max-height: 40vh;\n    display: flex;\n    flex-direction: column;\n    /* background: #f8fafc; */\n    border-radius: 0.375rem;\n    padding: 1rem;\n    margin-top: 1rem;\n  }\n  \n  /* ==========================================================================\n     2. 카드 구조 스타일링\n     ========================================================================== */\n  .card-news-item {\n    border: none;\n    border-radius: 20px;\n    overflow: hidden;\n    background: white;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .card-news-content {\n    aspect-ratio: 9/16;  /* 모바일 화면 비율 */\n    padding: 30px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  /* ==========================================================================\n     3. 텍스트 스타일링\n     ========================================================================== */\n  /* 카드 제목 */\n  .card-title {\n    font-size: 28px;\n    font-weight: bold;\n    color: #008275;  /* DB손보 브랜드 컬러 */\n    text-align: center;\n    word-break: keep-all;\n    line-height: 1.4;\n    margin-bottom: 10px;\n  }\n  \n  /* 카드 설명 텍스트 */\n  .card-description {\n    font-size: 16px;\n    color: #333;\n    line-height: 1.8;\n    word-break: keep-all;\n    white-space: pre-line;\n    text-align: center;\n    margin: 20px 0;\n  }\n  \n  /* 텍스트 래핑 유틸리티 */\n  .text-wrap {\n    white-space: pre-line;\n    word-break: keep-all;\n    overflow-wrap: break-word;\n  }\n  \n  /* ==========================================================================\n     4. 이미지 섹션\n     ========================================================================== */\n  .card-image {\n    flex: 1;\n    width: 100%;\n    padding: 20px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: transparent;\n  }\n  \n  .generated-image {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: 15px;\n  }\n  \n  /* ==========================================================================\n     5. 푸터 영역\n     ========================================================================== */\n  .card-footer {\n    margin-top: auto;\n    padding: 20px 0;\n    text-align: center;\n  }\n  \n  .company-logo {\n    height: 40px;\n    object-fit: contain;\n  }\n  \n  /* ==========================================================================\n     6. 버튼 스타일링\n     ========================================================================== */\n  /* 버튼 컨테이너 */\n  .card-news-controls {\n    margin-bottom: 20px;\n    text-align: center;\n  }\n  \n  /* 전체 다운로드 버튼 */\n  .download-all-button {\n    background-color: #008275;\n    color: white;\n    padding: 12px 24px;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: bold;\n    transition: all 0.3s ease;\n  }\n  \n  .download-all-button:hover {\n    background-color: #006c61;\n    transform: translateY(-2px);\n  }\n  \n  /* 개별 다운로드 버튼 */\n  .download-button {\n    padding: 10px 22px;\n    /* background-color: #f0f0f0; */\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-weight: bold;\n    color: #333;\n  }\n  \n  .download-button:hover {\n    background-color: #e0e0e0;\n    transform: translateY(-2px);\n  }\n  \n  /* 비활성화 상태 스타일 */\n  .download-button:disabled,\n  .download-all-button:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n    transform: none;\n  }\n\n  .persona-section{\n    width: 100%;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
